<template>
  <base-material-alert
    v-if="error"
    id="api-error-alert"
    :color="$vuetify.theme.dark ? 'softBackgroundRed' : 'softError'"
    :class="{
      'secondary--text': !$vuetify.theme.dark,
      'white--text': $vuetify.theme.dark,
    }"
  >
    <span v-if="error">
      {{ $t(`apiErrors.${error}`) }}
    </span>
  </base-material-alert>
</template>

<script>
export default {
  props: {
    error: {
      type: String,
      default: null,
    },
  },
  methods: {
    scrollToError() {
      setTimeout(
        () =>
          document.getElementById('api-error-alert').scrollIntoView({
            behavior: 'smooth',
          }),
        200
      )
    },
  },
}
</script>
